// extracted by mini-css-extract-plugin
export default {"wrapper":"NoReferrals_wrapper__SWnTA","title":"NoReferrals_title__IT5jS","subtitle":"NoReferrals_subtitle__K4575"};